<template>
  <div>
    <ul class="nav nav-tabs" role="tablist">
      <li class="active">
        <a
          href="#fabric-panel"
          role="tab"
          data-toggle="tab"
          aria-expanded="true"
        >
          Update Fabric Details
        </a>
      </li>
      <li class="">
        <a
          href="#fabric-image-panel"
          role="tab"
          data-toggle="tab"
          aria-expanded="false"
        >
          Manage Images
        </a>
      </li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane active" id="fabric-panel">
        <h3 class="header-row semi-bold">
          Update {{ fabric.name }}

          <span class="pull-right"
            >viewing this Fabric's configuration at
            <span class="semi-bold text-primary">{{
              getCurrentConfiguration()
            }}</span></span
          >
        </h3>

        <div class="alert alert-danger mt-20" v-if="Object.keys(errors).length">
          <h4 class="semi-bold text-danger">
            <span class="fa fa-exclamation-triangle"></span> Sorry, there were
            some errors!
          </h4>
          <p class="text-danger">
            Please check the form, correct the issues and try again.
          </p>
        </div>

        <!-- General Fabric Detail -->
        <div class="grid shadow bg-white">
          <div class="grid-title">
            <div class="row">
              <div class="col-md-6">
                <h4>General Fabric Detail</h4>
              </div>
              <div class="col-md-6 text-right">
                <button
                  class="btn btn-sm btn-primary"
                  @click="loadConfigFromFabricOnly()"
                >
                  Load From Fabric
                </button>
                <button
                  class="btn btn-sm btn-primary"
                  @click="loadConfigFromLastOrder()"
                >
                  Load From Last Order
                </button>
              </div>
            </div>
          </div>
          <div class="grid-body">
            <div class="row">
              <!-- Fabric Form Fields Wrapper -->
              <FabricGeneralDetails
                v-if="pageLoaded"
                :modelValues="fabric"
                :fieldValues="fieldValues"
                :isReadOnlyUser="isReadOnlyUser"
                :errors="errors"
              >
              </FabricGeneralDetails>
              <!-- Fabric Form Fields Wrapper -->
            </div>
          </div>
        </div>
        <!-- General Fabric Detail -->

        <div class="row d-flex">
          <!-- Additional Fabric Details -->
          <div class="col-md-6 d-flex">
            <div class="grid shadow bg-white">
              <div class="grid-title">
                <h4>Additional Fabric Detail</h4>
              </div>
              <div class="grid-body">
                <FabricAdditionalDetail
                  v-if="pageLoaded"
                  :modelValues="fabric"
                  :fieldValues="fieldValues"
                  :isReadOnlyUser="isReadOnlyUser"
                  :errors="errors"
                >
                </FabricAdditionalDetail>
              </div>
            </div>
          </div>
          <!-- Additional Fabric Details -->

          <!-- Fabric Dimension and Price Details -->
          <div class="col-md-6 d-flex">
            <div class="grid shadow bg-white">
              <div class="grid-title">
                <h4>Fabric Dimensions and price details</h4>
              </div>
              <div class="grid-body">
                <FabricDimensionPriceDetails
                  v-if="pageLoaded"
                  :modelValues="fabric"
                  :fieldValues="fieldValues"
                  :errors="errors"
                >
                </FabricDimensionPriceDetails>
              </div>
            </div>
          </div>
          <!-- Fabric Dimension and Price Details -->
        </div>

        <!-- Save Fabric Button -->

        <div v-if="selectedOrderId === null && !isReadOnlyUser" class="row">
          <div class="col-md-12">
            <button
              class="btn-primary btn-large btn btn-block mb-15"
              @click="saveConfiguration(true)"
            >
              Update Fabric
            </button>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-md-6" v-if="!isReadOnlyUser">
            <button
              class="btn-primary btn-large btn btn-block mb-15"
              @click="saveConfiguration(true)"
            >
              Update Fabric
            </button>
          </div>
          <div class="col-md-6" v-if="!isReadOnlyUser">
            <button
              class="btn-primary btn-large btn btn-block mb-15"
              @click="saveConfiguration()"
            >
              Update Order at Configuration {{ getCurrentConfiguration() }}
            </button>
          </div>
        </div>

        <!-- Save Fabric Button -->

        <!-- Show Previous Orders -->
        <div class="grid shadow bg-white">
          <div class="grid-body">
            <div class="row">
              <div class="col-md-8">
                <h4>Latest orders for this Fabric</h4>
              </div>
              <div class="col-md-4">
                <input
                  type="text"
                  v-model="orderSearch.keyword"
                  @keyup.enter="getFabricOrders()"
                  placeholder="Supplier Name"
                  class="form-control form-control-sm"
                />
              </div>
            </div>
          </div>

          <div id="order-table" class="grid-body">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="bg-primary">Invoice Ref</th>
                  <th class="bg-primary">Supplier</th>
                  <th class="bg-primary">Invoice Date</th>
                  <th class="bg-primary">Payment Date</th>
                  <th class="bg-primary">Delivery Date</th>
                  <th class="bg-primary"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(order, index) in orders"
                  :class="{ selected: order.selected }"
                  :key="index"
                >
                  <td>
                    <router-link
                      :to="{
                        name: 'fabric_order_update',
                        params: { order_id: order.order_id },
                      }"
                    >
                      {{ order.order_reference }}
                      <span v-if="order.in_use" class="in-use-roll">
                        (<span class="fa fa-star"></span> Roll In Use)
                      </span>
                    </router-link>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'fabric_suppliers_update',
                        params: { supplier_id: order.supplier.id },
                      }"
                    >
                      {{ order.supplier.name }}
                    </router-link>
                  </td>
                  <td>{{ ezy.date(order.invoice_date) }}</td>
                  <td>{{ ezy.date(order.payment_date) }}</td>
                  <td>{{ ezy.date(order.delivery_date) }}</td>
                  <td>
                    <button
                      v-if="order.order_id !== selectedOrderId"
                      class="btn btn-info"
                      @click="loadConfigFromSelectedOrder(order)"
                    >
                      Load configuration
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- Show Previous Orders -->
      </div>

      <div class="tab-pane" id="fabric-image-panel">
        <div class="grid shadow bg-white">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="sort" @click="sort('id')">#ID</th>
                <th class="sort" @click="sort('type')">Type</th>
                <th class="sort" @click="sort('image_url')">Image Preview</th>
                <th class="sort" @click="sort('variant')">Variant</th>
                <th class="text-right">
                  <button
                    class="btn btn-success"
                    @click="showCreateImageDialog()"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-plus-circle" aria-hidden="true"></i> Upload
                    New Image
                  </button>

                  <button class="btn btn-success" @click="reloadImages()">
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                  </button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(image, index) in fabric.images" :key="index">
                <td># {{ image.id }}</td>
                <td>{{ image.type_text }}</td>
                <td><img :src="image.image_url" width="100" /></td>
                <td>
                  {{
                    image.variant
                      ? image.variant[0].toUpperCase() + image.variant.slice(1)
                      : "Default"
                  }}
                </td>
                <td class="text-right">
                  <button
                    class="btn btn-primary"
                    @click="showUpdateImageDialog(index)"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i>
                    Edit
                  </button>
                  <button
                    class="btn btn-danger"
                    :class="{ disabled: imageButtonProcessing }"
                    @click="deleteImage(index)"
                    v-if="!isReadOnlyUser"
                  >
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                    Delete
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="fabric-upload-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold" v-if="imageId != null">
              Update Image
            </h5>
            <h5 class="modal-title text-bold" v-else>Create Image</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label for="">Type </label>
              <v-select
                placeholder="Choose One"
                v-model="imageFormData.type"
                :options="fieldValues.imageTypes"
                label="title"
                :reduce="(imageType) => imageType.key"
              />
            </div>
            <div class="form-group">
              <label for="">Type </label>
              <v-select
                placeholder="Choose One"
                v-model="imageFormData.variant"
                label="label"
                :options="
                  imageId !== null
                    ? [
                        { value: null, label: 'Default' },
                        { value: 'landscape', label: 'Landscape' },
                        { value: 'portrait', label: 'Portrait' },
                      ]
                    : [
                        { value: 'landscape', label: 'Landscape' },
                        { value: 'portrait', label: 'Portrait' },
                      ]
                "
                :reduce="(variant) => variant.value"
              />
            </div>
            <div class="row">
              <FabricUploadImage
                v-model="imageFormData.image_url"
                :error="errors.image_url"
                ref="uploadImageComponent"
              ></FabricUploadImage>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              :class="{ disabled: imageButtonProcessing }"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: imageButtonProcessing }"
              v-if="imageId != null"
              @click="updateImage()"
            >
              Update
            </button>
            <button
              type="button"
              class="btn btn-primary"
              :class="{ disabled: imageButtonProcessing }"
              v-else
              @click="createImage()"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FabricUploadImage from "./components/FabricUploadImage";
import FabricGeneralDetails from "./components/FabricGeneralDetails";
import FabricAdditionalDetail from "./components/FabricAdditionalDetail";
import FabricDimensionPriceDetails from "./components/FabricDimensionPriceDetails";
import app from "../Tools/Fabric";

export default {
  components: {
    FabricUploadImage,
    FabricGeneralDetails,
    FabricAdditionalDetail,
    FabricDimensionPriceDetails,
  },
  data() {
    return {
      /**
       * Added this property here because props are being dynamically passed
       * to the child components, so if the getPageData() promise is not fulfilled,
       * the child components do not get the proper prop values. This property
       * delays the loading of the child components until getPageData() is completed
       */
      isReadOnlyUser: false,
      pageLoaded: false,
      inHistoricalOrderMode: true,
      currentConfigurationName: "Roll in Use",
      loadedConfigurationId: null,
      fabricConfigOrderId: null,
      errors: {},
      fabricId: null,
      fieldValues: {
        weaves: [],
        fibers: [],
        finishes: [],
        patterns: [],
        coloringStyles: [],
        fabricTypes: [],
        suppliers: [],
        imageTypes: [],
        buttonColors: [],
        threadColors: [],
        embroideryThreadColors: [],
        fabricFamilies: [],
        usageTypes: [],
        compositionLabels: [],
        formattedCompositionLabels: [],
      },
      fabric: {
        id: null,
        name: null,
        pattern: null,
        comfort: null,
        default_currency: "THB",
        wrinkles: null,
        ironing: null,
        fiber_1: null,
        fiber_1_percentage: null,
        fiber_2: null,
        fiber_2_percentage: null,
        fiber_3: null,
        fiber_3_percentage: null,
        fabric_composition_label_id: null,
        default_weave: null,
        default_width: null,
        default_height: null,
        default_unit: "m",
        default_unit_price: null,
        default_vat_per_unit: null,
        default_unit_price_total: null,
        default_yarn_count: null,
        default_density: null,
        default_weight: null,
        default_coloring_style: null,
        color_family: null,
        usage_type: null,
        knit_type: null,
        default_finish: null,
        current_fabric_supplier_id: null,
        current_fabric_supplier_code: null,
        button_color_id: null,
        thread_color_id: null,
        embroidery_thread_color_id: null,
        fabric_family_id: null,
        is_shirt_fabric: 1,
        is_stretch_fabric: 0,
        is_jersey_fabric: 0,
        gender_suitable_for: "male",
        type: "Main",
        sample_book: 1,
        status: "available",
        future: "keep",
        note: "",
        matching: 1,
        design_extra: 0,
        interlining_color: "black",
        interlining: "hard",
        images: [],
        order_id: null,
        special_description_suffix: null,
        description: null,
        description_en: null,
        repetition_wrap: 0,
        repetition_weft: 0,
        usable_width: 0,
      },
      orders: null,
      /* copy of fabric */
      originalFabric: null,
      selectedOrderId: null,
      selectedOrder: null,
      orderSearch: {
        keyword: null,
        limit: 20,
        page: 1,
      },
      imageButtonProcessing: false,
      imageId: null,
      imageFormData: {
        type: null,
        image: "",
        variant: "default",
      },
    };
  },
  watch: {
    $route: function () {
      this.fabricId = this.$route.params.id;
      this.getPageData();
    },
  },
  mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    this.fabricId = this.$route.params.id;
    this.getPageData();
  },
  methods: {
    async getPageData() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/" + this.fabricId + "/edit",
        });

        const data = results.data.data;

        this.fieldValues = data;

        this.fabric = data.fabric;
        this.originalFabric = data.fabric;
        this.defaultFabric = data.default;
        this.pageLoaded = true;
        /**
         * This should be the config from the current roll in use
         */
        this.fabricConfigOrderId = data.configOrderId;
        this.fieldValues.formattedCompositionLabels = app.getFormattedCompositionLabels(
          this.fieldValues.compositionLabels
        );

        this.getFabricOrders(true);

        /**
         * After getting the list of orders, check if the roll in use is listed
         */
        let order = this.orders.find(
          (order) => (order.order_id = data.configOrderId)
        );
        if (order) {
          this.currentConfigurationName = "Last Order" + order.order_reference;
        } else {
          this.currentConfigurationName = "Roll in Use";
        }
      } catch (error) {
        // this.$router.push('/404');
      }
    },

    async getFabricOrders(initial = false) {
      let res = await axios.get("/v2/fabrics/orders", {
        params: {
          fabric_id: this.fabricId,
          keyword: this.orderSearch.keyword,
        },
      });

      this.orders = res.data.data.map((f) => {
        if (initial) {
          if (f.order_id === this.fabricConfigOrderId) {
            f["in_use"] = true;
            f["selected"] = true;
            this.currentConfigurationName = f.order_reference;
            this.selectedOrder = f;
            this.selectedOrderId = this.fabricConfigOrderId;
          } else {
            f["in_use"] = false;
            f["selected"] = false;
          }
        }
        return f;
      });

      if (this.selectedOrder) {
        this.loadConfigFromSelectedOrder(this.selectedOrder);
      }
    },

    async saveConfiguration(fabricOnly = false) {
      let fabricOnlyConfirmationMessage = this.selectedOrderId
        ? "Are you sure to overwrite the fabric ?"
        : "Are you sure to update the fabric ?";

      let fabricOnlyConfirmationBodyMessage = this.selectedOrderId
        ? "The fabric will be overwritten with the order configuration at " +
          this.getCurrentConfiguration()
        : "";

      let confirmationMessage = fabricOnly
        ? fabricOnlyConfirmationMessage
        : "Are you sure to update the order ?";

      let confirmationBodyMessage = fabricOnly
        ? fabricOnlyConfirmationBodyMessage
        : "Change in Supplier and Supplier code will be ignored when updating an order";

      if (
        await ezy.confirm(confirmationMessage, "YES", confirmationBodyMessage)
      ) {
        this.errors = {};
        try {
          if (fabricOnly) {
            this.fabric["order_id"] = null;
          } else {
            this.fabric["order_id"] = this.selectedOrderId;
          }

          let response = await axios.put(
            "/v2/fabrics/" + this.fabricId,
            this.fabric
          );
          if (response.data.status) {
            toastr.success("Successfully Updated");
          }

          /**
           * If the current supplier have been changed, we need to reload the list of orders
           * to display the new supplier reference in the list of orders
           */
          if (
            this.fabric["current_fabric_supplier_id"] !==
            this.selectedOrder.supplier.id
          ) {
            this.getFabricOrders(true);
          }
        } catch (error) {
          window.scrollTo(0, 0);
          if (error.response.status === 403) {
            toastr.error(
              "Not authorized, please ensure that you have the required permissions."
            );
          } else {
            this.errors = error.response.data.errors;
            toastr.error(
              "There was some errors, please correct and try again, or contact the admins"
            );
          }
        }
      }
    },

    getCurrentConfiguration() {
      return this.currentConfigurationName;
    },

    /**
     * Load the configuration from one of the orders listed below the fabric details
     */
    async loadConfigFromSelectedOrder(order) {
      this.loadConfigByType("specific_order", order);
    },

    /**
     * Load the configuration from the lastet order placed for this fabric
     */
    async loadConfigFromLastOrder() {
      this.loadConfigByType("last_order", null);
    },

    /**
     * Load the configuration from the data in the fabrics table
     */
    async loadConfigFromFabricOnly() {
      this.loadConfigByType("fabric_only", null);
    },

    async loadConfigByType(type, order) {
      let serviceUrl =
        order !== null
          ? `v2/fabrics/${this.fabricId}/configuration/${type}?order_id=${order.order_id}`
          : `v2/fabrics/${this.fabricId}/configuration/${type}`;

      let response = await axios.get(serviceUrl);
      let data = response.data.data;

      /**
       * Fallback check and warning in case the requested config could not be loaded
       */
      if (data.loaded === "roll_in_use") {
        this.selectedOrderId = data.config.order_id;
        if (type === "last_order") {
          toastr.warning(
            "Last order config not found, loading roll in use !!!"
          );
        }
        if (type === "specific_order") {
          toastr.warning(
            "Selected order config not found, loading roll in use !!!"
          );
        }
      } else if (data.loaded === "fabric_only") {
        this.selectedOrderId = null;
        this.selectedOrder = null;
        this.currentConfigurationName = "Fabric";
      } else {
        this.selectedOrderId = data.config.order_id;
      }

      this.highlightSelectedOrder();

      this.restoreImages(data.config);

      window.scrollTo(0, 0);
    },
    /**
     * hightlight the order config loaded from the API
     */
    highlightSelectedOrder() {
      if (this.selectedOrderId) {
        this.orders.map((order) => {
          if (order.order_id === this.selectedOrderId) {
            order.selected = true;
            this.selectedOrder = order;
            this.currentConfigurationName = order.order_reference;
          } else {
            order.selected = false;
          }
        });
      }
    },

    /**
     * The configuration data does not contain the original image data.
     * So we need to save it temporarely, then restore it to the fabric.
     */
    restoreImages(config) {
      const images = this.fabric.images;
      this.fabric = config;
      this.fabric.images = images;
    },

    /* Fabric Image methods */

    async reloadImages() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/fabrics/" + this.fabricId + "/images",
        });
        this.fabric.images = results.data.data;
        // Image list does not reload properly on the screen without this
        this.$forceUpdate();
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("There was an error reloading the results");
        }
      }
    },

    showCreateImageDialog() {
      this.imageId = null;
      this.imageFormData = {};
      this.$refs.uploadImageComponent.clearPreview();
      show_modal("#fabric-upload-modal");
    },

    showUpdateImageDialog(index) {
      let data = this.fabric.images[index];
      this.imageFormData = {
        type: data.type,
        variant: data.variant,
      };
      this.imageId = data.id;
      this.$refs.uploadImageComponent.setPreview(data.image_url);
      show_modal("#fabric-upload-modal");
    },

    async createImage() {
      let formData = new FormData();
      formData.append("fabric_id", this.fabricId);
      formData.append("image", this.imageFormData.image_url);
      formData.append("type", this.imageFormData.type);
      formData.append("variant", this.imageFormData.variant);

      try {
        this.imageButtonProcessing = true;
        let result = await axios.post(
          "/v2/fabrics/" + this.fabricId + "/images",
          formData
        );
        if (result.data.status) {
          this.reloadImages();
          toastr.success("Image successfully uploaded");
          hide_modal("#fabric-upload-modal");
        }
        this.imageButtonProcessing = false;
      } catch (error) {
        this.imageButtonProcessing = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(this.formatErrorMessagesForField("image", error));
        }
      }
    },

    async updateImage() {
      let formData = new FormData();
      formData.append("fabric_id", this.fabricId);
      formData.append("image", this.imageFormData.image_url);
      formData.append("type", this.imageFormData.type);
      formData.append("variant", this.imageFormData.variant);
      formData.append("_method", "PUT");

      try {
        this.imageButtonProcessing = true;
        /** see: https://stackoverflow.com/q/54686218 for why are are using a post here! **/
        let result = await axios.post(
          "/v2/fabrics/" + this.fabricId + "/images/" + this.imageId,
          formData
        );
        if (result.data.status) {
          this.reloadImages();
          toastr.success("Image successfully updated");
          hide_modal("#fabric-upload-modal");
        }
        this.imageButtonProcessing = false;
      } catch (error) {
        this.imageButtonProcessing = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(this.formatErrorMessagesForField("image", error));
        }
      }
    },

    async deleteImage(index) {
      let data = this.fabric.images[index];
      try {
        this.imageButtonProcessing = true;
        let result = await axios.delete(
          "/v2/fabrics/" + this.fabricId + "/images/" + data.id
        );
        this.reloadImages();
        toastr.success("Image deleted");
        this.imageButtonProcessing = false;
      } catch (error) {
        this.imageButtonProcessing = false;
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(this.formatErrorMessagesForField("image", error));
        }
      }
    },
    /**
     * Glue all the error messages of a field after validation from the backend.
     */
    formatErrorMessagesForField(field, error) {
      if (error.response.status === 422) {
        // Error triggered by request validation
        let errorMessage = error.response.data.message; // Set default error message
        if (error.response.data.errors.hasOwnProperty(field)) {
          errorMessage = error.response.data.errors[field].join(", ");
        }
        return errorMessage;
      } else if (error.response.status === 413) {
        // Error triggered by HTTP server (Apache/Nginx) configutation
        return "Image size is too large";
      }
      return "Unknown error";
    },
  },
};
</script>

<style scoped>
@import "~vue-slider-component/theme/default.css";
@import "~vue-select/dist/vue-select.css";

.header-row {
  margin-bottom: 20px;
}

.header-row span {
  font-size: 18px;
  font-weight: normal !important;
}

.header-row span span.semi-bold {
  font-weight: bold !important;
}

.col-form-label {
  margin-top: 10px;
}

.form-control {
  border-radius: 5px !important;
}

.slider-container {
  margin-top: 10px;
}

.d-flex {
  display: flex !important;
}

.d-flex .grid {
  width: 100%;
}
.mb-15 {
  margin-bottom: 15px !important;
}
#order-table tr.selected td {
  background: #fb46022e;
  color: #fb4602 !important;
  font-weight: bold !important;
}
#order-table {
  padding-top: 0px !important;
}
.in-use-roll,
#order-table tr.selected td a {
  color: #fb4602;
  font-weight: bold;
}
</style>
